var _polygon, _polygon2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#616161",
    points: "41,6 9.929,42 6.215,42 37.287,6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    fillRule: "evenodd",
    points: "31.143,41 7.82,7 16.777,7 40.1,41",
    clipRule: "evenodd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M15.724,9l20.578,30h-4.106L11.618,9H15.724 M17.304,6H5.922l24.694,36h11.382L17.304,6L17.304,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoX);
export default __webpack_public_path__ + "static/media/trvto_x.1a9753b68b08c5bfa817b70ee179e9f4.svg";
export { ForwardRef as ReactComponent };